module.exports = __webpack_public_path__ + "static/img/bonus_2.9260324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/bonus_2.png
// module id = Iwz5
// module chunks = 0